import request from 'request-promise';

import { WAITLIST_API_URL } from './urls';
import thunker from './thunker';

export const SUBMIT_CONTACT = "SUBMIT_CONTACT";
export const SUBMIT_CONTACT_FAILURE = "SUBMIT_CONTACT_FAILURE";
export const SUBMIT_CONTACT_SUCCESS = "SUBMIT_CONTACT_SUCCESS";



export const submitContactMessage = (name, email, message) => {
  return thunker({
    types: [
      SUBMIT_CONTACT,
      SUBMIT_CONTACT_SUCCESS,
      SUBMIT_CONTACT_FAILURE,
    ],
    promise: sendContact(name, email, message),
    data: { name, email, message }
  });
};

function sendContact(name, email, message) {
  return new Promise((resolve, reject) => {
    if (!name) {
      reject(new Error('Please enter your name.'));
    } else if (!email) {
      reject(new Error('Please enter your email.'));
    } else if (!message) {
      reject(new Error('Please enter a message.'));
    } else {
      const options = {
        method: 'POST',
        body: {
          name,
          email,
          message,
        },
        uri: `${WAITLIST_API_URL}/createContactMessage`,
        json: true,
      };

      request(options)
        .then((res) => {
           resolve(true);
        })
        .catch((err) => {
          reject(getErrorMessage(err));
        });
    }
  });
}

//
// API returns errors in the format
//   {
//     error: {
//       errors: [
//         {},
//       ],
//     }
//   }
//
//
function getErrorMessage(errObj) {
  const errors = errObj.error.errors;

  switch(errors[0].param) {
    case 'name':
      return new Error('Please use your first and last name.');
    case 'email':
      return new Error('Please confirm your email.');
    case 'message':
      return new Error('Please enter a message.');
    default:
      return new Error('There was an error processing your contact. Please try again later');
  }
}



// WEBPACK FOOTER //
// ./src/actions/contactActions.js